import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout({ children, withTopPadding = true }) {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--sv-bg)] text-white">
      <Navbar />
      <main className={`flex-1 ${withTopPadding ? "pt-20" : ""}`}>{children}</main>
      <Footer />
    </div>
  );
}
